import { useDispatch, useSelector } from 'react-redux';

import {
  toggleDepartureTimeFilter,
  clearDepartureTimeFilter,
} from '../../actions/filter-actions';
import { getDepartureTimesSelected } from '../../selectors';

import { useDepartureTimesFilterTracking } from './useDepartureTimesFilterTracking';

import type { DepartureTime } from '../constants/departureTimeConstants';

export const useDepartureTimesFilter = () => {
  const dispatch = useDispatch();
  const selectedTimes = useSelector(getDepartureTimesSelected);
  const { trackFilterChange } = useDepartureTimesFilterTracking();

  const onChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
    multi?: boolean,
  ) => {
    const selectedTime = event.target.value;

    trackFilterChange(() => {
      if (multi) {
        dispatch(toggleDepartureTimeFilter(selectedTime as DepartureTime));
        return;
      }

      dispatch(clearDepartureTimeFilter());
      if (selectedTime === 'ANYTIME') return;
      dispatch(toggleDepartureTimeFilter(selectedTime as DepartureTime));
    });
  };

  return { selectedTimes, onChange };
};
